import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import CredibilityStrip from "@/components/CredibilityStrip";
import About from "@/components/About";
import CareerHighlights from "@/components/CareerHighlights";
import MadridHorseWeek from "@/components/MadridHorseWeek";
import NationalLeague from "@/components/NationalLeague";
import RideTV from "@/components/RideTV";
import Skills from "@/components/Skills";
import Expertise from "@/components/Expertise";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Portfolio() {
  return (
    <main data-testid="portfolio-page" className="bg-white text-[#111] font-sans-body">
      <Navbar />
      <Hero />
      <CredibilityStrip />
      <About />
      <CareerHighlights />
      <NationalLeague />
      <MadridHorseWeek />
      <RideTV />
      <Skills />
      <Expertise />
      <Contact />
      <Footer />
    </main>
  );
}
